<template>
  <main class="app">
    <div class="main-header col-9 col-sm-12 pr-0 pr-lg-2">
      <h1>Logistica Muvin</h1>

      <!-- <button class="btn btn--with-icon btn--small success" @click="openPopup">
        <i class="vs-icon notranslate icon-scale material-icons null"
          >add_circle</i
        >
        Crear Oferta
      </button> -->
    </div>

    <div class="offer-list">
      <delivery-list
        view="admin"
        ref="deliveryList"
        :storeDestiny="'adminOffersList'"
        :autoload="true"
        :admin="true"
        :offers-states="[
          'order_muvin_pending',
          'order_muvin_published',
          'order_muvin_finished',
          'order_muvin_expired',
        ]"
      />
    </div>

    <!-- PopUp crear oferta -->
    <vs-popup
      title="Crear oferta"
      :active.sync="createOfferPopup"
      class="popup-create-offer"
    >
      <form>
        <div class="input-group">
          <select
            name="org"
            data-test="select-entity-admin"
            v-validate="'required'"
            :danger="this.errors.has('org')"
            v-model="organization"
            :class="{ changed: !!organizations }"
            @change="getEstablishmentsByOrganization"
          >
            <option value="" disabled>Entidad</option>
            <option
              :key="index"
              :value="index"
              v-for="(org, index) in organizations"
            >
              {{ org.businessName }}
            </option>
          </select>
          <label for="org">Entidad</label>
          <div
            class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
          >
            <span> {{ this.errors.first("org") }}</span>
          </div>
        </div>

        <div class="input-group">
          <select
            name="est"
            data-test="select-establishment-admin"
            v-validate="'required'"
            :danger="this.errors.has('est')"
            v-model="establishment"
            :class="{ changed: !!establishments }"
          >
            <option value="" disabled>Establecimientos</option>
            <option
              :key="index"
              :value="index"
              v-for="(est, index) in establishments"
            >
              {{ est.name }} {{ est.city }}
            </option>
          </select>
          <label for="org">Establecimientos</label>
          <div
            class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
          >
            <span> {{ this.errors.first("est") }}</span>
          </div>
        </div>

        <div
          class="section-heading__actions d-grid g-template-columns-2-fr g-gap-10"
        >
          <div
            disabled
            data-test="createofferofbuy-admin"
            class="btn btn--popup"
            :class="{ buyer: marketRoleBuyer }"
          >
            Oferta de compra
          </div>
          <div
            disabled
            data-test="createofferofsell-admin"
            class="btn btn--popup"
            :class="{ seller: marketRoleSeller }"
          >
            Oferta de venta
          </div>
        </div>

        <div class="input-group">
          <select
            name="email"
            data-test="select-email-admin"
            v-validate="'required'"
            :danger="this.errors.has('email')"
            v-model="email"
            :class="{ changed: !!emailsFromAdmin }"
          >
            <option value="" disabled>Notificar a</option>
            <option v-for="(e, index) in emailsFromAdmin" :key="index">
              {{ e.email }}
            </option>
          </select>
          <label for="org">Notificar a</label>
          <div
            class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
          >
            <span> {{ this.errors.first("email") }}</span>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-6">
          <button
            class="btn btn--with-icon btn--small success w-100 w-md-auto ml-2"
            @click.prevent="continueCreation"
          >
            Continuar con la creación de la oferta
          </button>
        </div>
      </form>
    </vs-popup>
  </main>
</template>

<script>
import DeliveryList from "@/components/DeliveryList.vue";
import OfferCreateForm from "@/components/OfferCreateForm.vue";
import OfferCloneForm from "@/components/OfferCloneForm.vue";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";
import { mapState, mapMutations } from "vuex";
import { Validator } from "vee-validate";

import organizationDetail from "../../graphql/queries/organizationDetail.gql";
import listOrganizations from "../../graphql/queries/listOrganizations.gql";

axios.defaults.headers.common["referer-id"] =
  new Date().toLocaleString().replace(/[^\d]/g, "") +
  parseInt(Math.random() * 100000);

export default {
  components: {
    "delivery-list": DeliveryList,
    "offer-create-form": OfferCreateForm,
    "offer-clone-form": OfferCloneForm,
  },
  data() {
    return {
      cleaning: false,
      currentPage: 1,
      createOfferPopup: false,
      organizations: [],
      establishments: [],
      organization: undefined,
      establishment: undefined,
      totalPages: "",
      email: "",
      pagination: 1,
      operationType: "",
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.User.currentUser,
    }),
    emailsFromAdmin: function () {
      if (this.establishments[this.establishment]) {
        return this.establishments[this.establishment].users;
      }
    },
    marketRoleSeller: function () {
      if (this.establishments[this.establishment]) {
        if (this.establishments[this.establishment].marketRole === "seller") {
          this.operationType = "sell";
          return true;
        } else {
          this.operationType = "buy";
          return false;
        }
      }
    },
    marketRoleBuyer: function () {
      if (this.establishments[this.establishment]) {
        if (this.establishments[this.establishment].marketRole === "buyer") {
          this.operationType = "buy";
          return true;
        } else {
          this.operationType = "sell";
          return false;
        }
      }
    },
  },
  methods: {
    openPopup() {
      this.createOfferPopup = true;
      this.operationType = '';

      this.getOrganizations()

      this.organization = undefined;
      this.establishment = undefined;
      this.establishments = [];
      this.email = '';
      this.$validator.reset()
     
    },
    getEstablishmentsByOrganization() {
      this.$vs.loading()
      let self = this;
            axios
              .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                params: {
                  query: print(organizationDetail),
                  variables: {
                    currentUserToken: localStorage.getItem("USER_TOKEN"),
                    organizationId: this.organizations[this.organization].id
                  },
                },
              })
              .then((res) => {
                self.establishments = res.data.data.organizationDetail.establishments.filter( a => a.active === true).sort(
                    (a, b) => a.name.localeCompare(b.name)
                  );
                this.$vs.loading.close();
              })
              .catch((err) => {
                this.$vs.loading.close();
              });
    },
    getOrganizations() {
      this.$vs.loading()
      let self = this;
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(listOrganizations),
            variables: {
              currentUserToken: localStorage.getItem("USER_TOKEN"),
              perPage: 999999,
              stateFilter: "enabled",
              sort: {
                sortBy: "business_name",
                desc: false
              }
            },
          },
        })
        .then((res) => {
          if (!res.data.errors) {
            self.organizations = res.data.data.listOrganizations.organizations;
            self.totalPages = res.data.data.listOrganizations.totalPages;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    continueCreation() {
    this.$validator.validate().then((res) => {
      if (res) {
        if (this.operationType) {
          let establishmentId = this.establishments[this.establishment].id
          let organizationId = this.organizations[this.organization].id
          let organizationEmail = this.establishments[this.establishment].users[0].email
            if (this.operationType == "buy") {
              this.$router.push({name:'create_buyer_offer_by_agent', params:{establishmentId, organizationId, organizationEmail}});
              this.createOfferPopup = false;
            } else {
              this.$router.push({name:'create_seller_offer_by_agent', params:{establishmentId,organizationId, organizationEmail}});
              this.createOfferPopup = false;
            }
          }
        }
      });
    },
  },
};
</script>
